import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

@Component({
  selector: 'pinnakl-local-spinner',
  templateUrl: 'local-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LocalSpinnerComponent {
  readonly classes = input('');
  readonly size = input('100px');
  readonly backgroundColor = input('rgba(255, 255, 255, 0.2)');
  readonly otherNgStyles = input<Record<string, string>>({});

  readonly ngStyles = computed<Record<string, string>>(() => ({
    backgroundSize: this.size(),
    backgroundColor: this.backgroundColor(),
    ...this.otherNgStyles(),
  }));
}
